import { defineMessages } from "react-intl";

import { node as asciticFluidCulture } from "src/modules/ltx/forms/phase-i/cultures/asciticFluidCulture";
import { node as nasalSwabCulture } from "src/modules/ltx/forms/phase-i/cultures/nasalSwabCulture";
import { node as stoolCulture } from "src/modules/ltx/forms/phase-i/cultures/stoolCulture";
import { node as throatSwabCulture } from "src/modules/ltx/forms/phase-i/cultures/throatSwabCulture";
import { node as urineCulture } from "src/modules/ltx/forms/phase-i/cultures/urineCulture";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.cultures",
		defaultMessage: "Tenyésztések"
	}
});

export const node: ParentNode = {
	id: "cultures",
	value: { type: "wizard", title: messages.title },
	children: [
		nasalSwabCulture,
		throatSwabCulture,
		urineCulture,
		asciticFluidCulture,
		stoolCulture
	]
};
